import { useEffect } from "react";
import * as Scrivito from "scrivito";
import getHomepage from "^/utils/getHomepage";
import { getKeycloak } from "^/Components/Authentication/keycloak";
import { useAuth } from "^/Components/Authentication/AuthenticationProvider";
import LoginButton from "^/Components/Navigation/LoginButton";

const NotLoggedin = Scrivito.connect(({ page }) => {
  const homepage = getHomepage(page);

  if (!homepage) {
    return null;
  }

  const loginLink = homepage.get("intranetLoginLink");
  const title =
    page.language() === "de" ? "Am Intranet anmelden" : "Login to the Intranet";

  return (
    <>
      <Scrivito.ContentTag content={page} attribute="content" />
      <div className="d-flex justify-content-center mb-3">
        <LoginButton
          loginLink={loginLink}
          title={title}
          homepage={homepage}
          className="btn btn-primary d-block mt-3"
        />
      </div>
    </>
  );
});

Scrivito.provideComponent(
  "LoginRedirectPage",
  Scrivito.connect(({ page }) => {
    const studentLink = page.get("intranetStudentLink");
    const employeeLink = page.get("intranetEmployeeLink");
    const keycloak = getKeycloak();
    const { authenticated, initialized } = useAuth();

    const getRolesFromToken = (tokenParsed = {}) => {
      const realmRoles = tokenParsed?.realm_access?.roles || [];
      const resourceRoles = Object.values(
        tokenParsed?.resource_access || {}
      ).flatMap((resource) => resource.roles || []);
      return Array.from(new Set([...realmRoles, ...resourceRoles]));
    };

    const roles = getRolesFromToken(keycloak?.tokenParsed);

    const isStudent = roles.includes("student");
    const isEmployee =
      roles.includes("employee") || roles.includes("hill-employee");

    useEffect(() => {
      if (!initialized) return;

      if (authenticated) {
        if (isStudent) {
          if (studentLink) {
            Scrivito.navigateTo(studentLink);
          }
        } else if (isEmployee) {
          Scrivito.navigateTo(employeeLink);
        } else {
          console.error(
            "Kein passender Benutzerrolle für Weiterleitung gefunden",
            roles
          );
        }
      }
    }, [
      initialized,
      authenticated,
      studentLink,
      employeeLink,
      isStudent,
      isEmployee,
      roles,
    ]);

    if (Scrivito.isInPlaceEditingActive()) {
      return (
        <div className="container mt-3">
          <h3>
            This page redirects to the folowing pages if a user is Logged in
          </h3>
          <div>
            <strong className="d-block">As Student</strong>
            {studentLink && (
              <Scrivito.LinkTag to={studentLink}>
                {studentLink.get("title")}
              </Scrivito.LinkTag>
            )}
          </div>
          <div>
            <strong className="d-block">As Employee</strong>
            {employeeLink && (
              <Scrivito.LinkTag to={employeeLink}>
                {employeeLink.get("title")}
              </Scrivito.LinkTag>
            )}
          </div>
          <h3>Content for Not logged in page</h3>
          <NotLoggedin page={page} />
        </div>
      );
    }

    return authenticated ? null : (
      <NotLoggedin page={page} title={page.get("loginButtonText")} />
    );
  })
);
